import * as angular from "angular";
import {
    FileItem,
    FileUploader,
    FileUploaderFactory,
} from "angular-file-upload";
import { CredentialsManager } from "../../shared/credentials-manager";
import { ToastUtils } from "../../helper/toast.helper";
import { CustomFieldAttachmentModel } from "../../models/custom-field-attachment.model";
import { HouseOccupant } from "../../models/house-occupant.model";
import { fileConstants } from "../../utils/constants/files.constants";

let CustomFieldAttachmentListItemComponent = {
    selector: "vcCustomFieldAttachmentListItem",
    templateUrl:
        "/angular/components/custom-fields/custom-field-attachment-list-item.component.html",
    bindings: {
        field: "=?",
        cfid: "=",
        clickable: "=",
        houseoccupant: "=",
    },
    controller: class CustomFieldAttachmentListItem {
        // * bindings for typescript compiler *
        public field?: any;
        public houseoccupant: HouseOccupant;
        public cfid: number;
        public clickable: boolean;
        // ************************************

        public $scope: any;
        public uploader: FileUploader;
        public toast: ToastUtils;
        public $timeout: any;
        public files: CustomFieldAttachmentModel[];
        public inputId: string;

        constructor(
            $scope: any,
            FileUploader: FileUploaderFactory,
            $timeout: any,
            CredentialsManager: CredentialsManager,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.toast = ToastUtils;
            this.uploader = new FileUploader({
                headers: {
                    Authorization:
                        "Bearer " + CredentialsManager.getAccessToken(),
                } as any,
                autoUpload: true,
                removeAfterUpload: true,
            });
            this.$timeout = $timeout;
        }

        $onInit() {
            this.inputId = "custom-field-attachment-" + this.field.cfid;
            this.$timeout(() => {
                angular
                    .element(document.querySelector("#" + this.inputId))
                    .on("change", this.handleFileSelect.bind(this));
            }, 200);

            this.uploader.onWhenAddingFileFailed = (item: FileItem) => {
                this.toast.error("File is not supported");
            };

            if (this.field.files) {
                this.files = this.field.files;
            } else {
                this.files = [];
                this.field.files = this.files;
            }
        }

        handleFileSelect(event: any): void {
            const file = event.currentTarget.files[0];

            if (file) {
                let reader: FileReader = new FileReader();

                this.$timeout(() => {
                    let allowedFileType = false;
                    const extension = this.getExtensionFromFileName(file.name);

                    angular.forEach(
                        fileConstants.allAcceptedFileTypes,
                        (type) => {
                            if (type == extension) {
                                allowedFileType = true;
                            }
                        }
                    );

                    if (allowedFileType) {
                        if (file.size <= 20971520) {
                            let fileName = angular.copy(file.name);
                            const alreadyTakenFileNames: string[] =
                                this.files.map(
                                    (file: CustomFieldAttachmentModel) =>
                                        file.name
                                );

                            let i: number = 1;
                            while (alreadyTakenFileNames.includes(fileName)) {
                                fileName =
                                    this.getFileNameWithoutExtension(fileName) +
                                    "(" +
                                    i +
                                    ")." +
                                    extension;
                                i++;
                            }

                            reader.onload = (evt: any) => {
                                this.$scope.$apply(($scope: any) => {
                                    this.files.push(
                                        new CustomFieldAttachmentModel({
                                            name: fileName,
                                            data: evt.target.result,
                                        })
                                    );
                                });
                            };
                            reader.readAsDataURL(file);
                        } else {
                            this.toast.error(
                                "File size too large, max size for attachments is 20MB"
                            );
                        }
                    } else {
                        this.toast.error("File type not supported");
                    }
                }, 150);
            }
        }

        getExtensionFromFileName(name: string): string {
            const splits: string[] = name.split(".");
            return splits[splits.length - 1].toLowerCase();
        }

        getFileNameWithoutExtension(name: string): string {
            return name.split(".").slice(0, -1).join(".");
        }
    },
};

angular
    .module("customField")
    .component(
        CustomFieldAttachmentListItemComponent.selector,
        CustomFieldAttachmentListItemComponent
    );
